import { createActions } from 'redux-actions';
export const SET_RECENT_SEARCHES = 'SET_RECENT_SEARCHES';
export const ADD_RECENT_SEARCH = 'ADD_RECENT_SEARCH';
export const { setRecentSearches, addRecentSearch } = createActions({
    [SET_RECENT_SEARCHES]: (locations) => locations,
    [ADD_RECENT_SEARCH]: (location) => location
});
